module.exports = __webpack_public_path__ + "img/lang-15.e837f715.jpg";